import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';
import { SectionCard } from '../common';
import { ListRowsSkeleton } from '../section-skeletons';

/**
 * `/api-keys` route pending state: Topbar + the same card `ApiKeysSection`
 * renders, so nothing resizes on handover. The card-header actions are
 * skeletoned (their role/plan gates aren't resolved yet).
 */
export function ApiKeysPendingState() {
  return (
    <>
      <Topbar
        crumbs={[{ label: 'Organization' }, { label: 'API Keys' }]}
        title="API Keys"
      />
      <div className="flex min-h-0 flex-1 flex-col overflow-auto" style={{ background: 'var(--canvas)' }}>
        <div
          className="mx-auto flex w-full flex-col gap-6 px-4 py-6 md:px-8 md:py-6"
          aria-busy="true"
          aria-live="polite"
        >
          <SectionCard tight>
            <div
              className="flex flex-wrap items-center justify-between gap-3"
              style={{ padding: '12px 18px' }}
              aria-hidden="true"
            >
              <Skeleton className="h-4 w-[110px] rounded-md" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-8 w-[96px] rounded-md" />
                <Skeleton className="h-8 w-[132px] rounded-md" />
              </div>
            </div>
            <div style={{ borderTop: '1px solid var(--ink-100)' }}>
              <ListRowsSkeleton rows={2} scopeChips />
            </div>
          </SectionCard>
        </div>
      </div>
    </>
  );
}
